import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
import type { ApproverLinkedAccount, FetchApproverLinkedAccountsRequest } from 'vopay';

const { api } = vopayApi;

export default function useFetchApproverLinkedAccounts() {
  const source = axios.CancelToken.source();
  const [fetching, setFetching] = useState(false);
  const [accounts, setAccounts] = useState<ApproverLinkedAccount[]>([]);

  useEffect(() => {
    return () => source.cancel();
  }, []);

  async function fetchApproverLinkedAccounts(params: FetchApproverLinkedAccountsRequest) {
    try {
      setFetching(true);
      const res = await api.fetchApproverLinkedAccounts(params, source);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setAccounts(res.Accounts);
      return res;
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error(error);
        throw error;
      }
    } finally {
      setFetching(false);
    }
  }

  return { fetching, accounts, fetchApproverLinkedAccounts };
}
